import { render } from "./ControlPackage.vue?vue&type=template&id=40a3d9b0&scoped=true&ts=true"
import script from "./ControlPackage.vue?vue&type=script&lang=ts"
export * from "./ControlPackage.vue?vue&type=script&lang=ts"

import "./ControlPackage.vue?vue&type=style&index=0&id=40a3d9b0&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a3d9b0"]])

export default __exports__